import project from "@/pages/project/project.vue"
import projectList from "@/pages/project/projectList.vue"
import {PathName} from "@/constant/routeData";
import projectEdit from "@/pages/project/projectEdit.vue";
import projectSummary from "@/pages/project/projectSummary.vue";
import projectKanban from "@/pages/project/projectKanban.vue";

export default [
  {
    path: '/project',
    name: PathName.ProjectInit,
    component: project,
  },
  {
    path: '/projectList',
    name: PathName.ProjectList,
    component: projectList,
  },
  {
    path:'/projectEdit/:project_id?',
    name: PathName.ProjectEdit,
    component: projectEdit
  },
  {
    path:'/projectSummary',
    name: PathName.ProjectSummary,
    component: projectSummary
  },
  {
    path: '/projectKanban',
    name: PathName.ProjectKanban,
    component: projectKanban,
  }
]
